import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../services/permission.service';
import { FlagService } from '../../shared/services/flag.service';
import { FlagType } from '../../shared/utils/enums';

/**
 * Blocks agency routes the connected role may not open (route `data: { permission: 'X' }`).
 * UI convenience only: the backend refuses the underlying calls anyway (403).
 */
export const permissionGuard: CanActivateFn = (route) => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  const flag = inject(FlagService);

  const required = route.data?.['permission'];
  if (!required || permissions.has(required)) {
    return true;
  }
  flag.displayFlag("Vous n'avez pas les droits nécessaires pour accéder à cette page.", FlagType.error);
  return router.parseUrl('/agency/dash');
};
